import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css'; // Reusing the same CSS for consistency

const TermsAndConditions = () => {
  const [termsText, setTermsText] = useState("Loading terms...");

  useEffect(() => {
    fetch('https://atrmart.in/terms-conditions.txt')
      .then(response => response.text())
      .then(data => {
        setTermsText(data);
      })
      .catch(err => {
        console.error("Failed to load terms:", err);
        setTermsText("Unable to load Terms & Conditions. Please contact support@atrmart.in");
      });
  }, []);

  return (
    <div className="policy-container">
      <header className="policy-header">
        <h1>Terms & Conditions</h1>
        <p>ATR AGRO MART | User Agreement</p>
      </header>

      <section className="policy-content">
        <div style={{ whiteSpace: 'pre-wrap', fontSize: '1rem', color: '#333' }}>
          {termsText}
        </div>
      </section>

      <div className="policy-footer-info">
        <h3>Legal Support</h3>
        <p>ATR SOLAR & ATR MART, Madurai</p>
        <p><strong>Contact:</strong> +91 93444 53444</p>
      </div>
    </div>
  );
};

export default TermsAndConditions;